












































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import { ShipmentDTO } from "../../../model/data.model";
import {
  ShipmentListItem,
  ShipmentManagementDef
} from "../../../model/component.model";
import { ShipmentService } from "../../../services/ShipmentService";

interface SelectableItem {
  selected: boolean;
}

@Component({})
export default class BillingManagementToolbar extends Vue {
  @Prop() selectedItems: SelectableItem[];

  selectedItemsCount() {
    return this.selectedItems.length;
  }
}
